import React, { createContext, useContext, useState } from "react";

const ErrorModalContext = createContext();

export const useErrorModal = () => useContext(ErrorModalContext);

export const ErrorModalProvider = ({ children }) => {
  const [modal, setModal] = useState({ open: false, message: "" });

  const showError = (message) => setModal({ open: true, message });
  const closeError = () => setModal({ open: false, message: "" });

  // console.log(showError, "-----------");

  return (
    <ErrorModalContext.Provider value={{ ...modal, showError, closeError }}>
      {children}
    </ErrorModalContext.Provider>
  );
};
